module.exports = __webpack_public_path__ + "static/media/roulette1.37be4373.png";